import { ImSpinner8 } from "react-icons/im";
import { getLcn } from '../utils/labeled-classnames';

const sizes = {
  none: '',
  sm: 'text-md',
  md: 'text-xl',
  lg: 'text-3xl',
}

export default function SpinnerTw({ center = true, size = 'sm' }: { center?: boolean, size?: keyof typeof sizes }) {
  const lcn = getLcn({
    spinner: [
      'animate-spin',
      'inline-block',
      sizes[size],
    ]
  });

  // <ImSpinner />
  // <ImSpinner2 />
  // <ImSpinner3 />
  // <ImSpinner4 />
  // <ImSpinner5 />
  // <ImSpinner6 />
  // <ImSpinner7 />
  // <ImSpinner8 />
  // <ImSpinner9 />
  // <ImSpinner10 />
  // <ImSpinner11 />

  let spinner = <ImSpinner8 className={lcn.spinner} />

  if (center === true) {
    return (
      <span className="flex items-center justify-center h-full w-full m-2">
        {spinner}
      </span>
    )
  } else {
    return spinner
  }
}

